<button
  class="qr-button subheading-01-semi-bold"
  [ngClass]="config.hierarchy"
  [class.disabled]="isDisabled"
  [class.iconOnly]="config.iconOnly"
  [class.is-loading-shimmer]="isShimmerLoading"
  matRipple
  [style.height.px]="config.size"
  [style.width.px]="config.iconOnly ? config.size : 'inherit'"
  [type]="config.type"
  [attr.aria-busy]="isLoaderVisible ? 'true' : null"
>
  <ng-container *ngIf="!isLoaderVisible || isShimmerLoading; else loader">
    <qr-icon
      *ngIf="config.icon"
      class="icon"
      [name]="config.icon"
      [size]="config.size"
      [color]="this.iconColor"
      [class.iconOnly]="config.iconOnly"
      [small]="config.size === sizeSmall"
    ></qr-icon>
    <ng-container *ngIf="!config.iconOnly">{{ config.viewValue }}</ng-container>
  </ng-container>
  <ng-template #loader>
    <div
      class="loader"
      [style.width.px]="config.iconOnly ? config.size : 'inherit'"
      [ngClass]="config.hierarchy"
    >
      <mat-spinner [diameter]="20"></mat-spinner>
    </div>
  </ng-template>
</button>
